﻿import { BaseTextContent } from '../BaseTextContent'

export const translations: BaseTextContent = {
    LinkButtonText: 'Link With My Accounting Package',
    SecurelySubmitPrompt: 'Securely Submit Financial Data',
    QBDesktop: 'Desktop',
    QBOnline: 'Online',
    Xero: 'Xero',
    SageIntacct: 'Sage Intacct',
    ExampleAccountingSystem: 'Example',
    ClickYourAccountingPackage: 'Click on your accounting package above to authorize a secure connection to the financial data needed to fulfill your application',
    PNLStatements: 'Profit & Loss Statements',
    BalanceSheets: 'Balance Sheets',
    TransactionData: 'Transaction Data',
    NoteNoPersonalInformation: 'Note: Strongbox does NOT gather personal information such as Social Security Numbers',
    EstablishingSecureConnection: 'Establishing secure connection',
    GatheringRequiredInformation: 'Gathering required information',
    DeliveringToYourAccountMgr: 'Delivering to your account manager',
    YourDataIsSubmitted: 'Your financial data has been submitted!',
    ImportingFinancials: 'Initiating financial data collection...',
    Done: 'Done',
    Continue: 'Continue',
    Dismiss: 'Dismiss',
    ConnectToAccountingPkg: 'Connect to',
    ConnectWithFileUpload: 'Upload Excel Template',
    DisconnectFromAccountingPkg: 'Disconnect',
    UnknownAccountingPkg: 'Unknown Accounting Package',
    ConnectAccountingSystemDetailedError: 'Unable to connect with ${accountingPackage}, response status: ${responseStatus}',
    ConnectAccountingSystemSummaryError: 'An error occurred communicating with the server, please try again later',
    StartFinancialsCreateRequestDetailedError: 'Unable to create request for ${accountingPackage}, response status: ${responseStatus}',
    StartFinancialsCreateRequestSummaryError: 'An error occurred communicating with the server, please try again later',
    StartFinancialsCreateWindowDetailedError: 'Failed creating window to connect with client acccounting system ${accountingPackage}',
    StartFinancialsCreateWindowSummaryError: 'An error occurred locally. Try closing your browser window and trying again later',
    StartFinancialsImportDetailedError: 'Failed creating a job to import financial records for ${accountingPackage}',
    StartFinancialsImportSummaryError: 'A failure occurred communicating with the server. Please try again later',
    LinkModalDescriptionQBO: 'After clicking \'Connect\', Intuit will prompt you to ' +
        'authorize a connection to QuickBooks.',
    LinkModalDescriptionQBD: 'After clicking \'Connect\', you will be shown instructions for ' +
        'installing \'Strongbox Connect\' and sharing your information. Once you have followed these ' +
        'instructions you\'ll be on your way!',
    LinkModalDescriptionXero: 'After clicking \'Connect\', Xero will prompt you to ' +
        'authorize a connection to Xero.',
    LinkModalDescriptionSageIntacct: 'After clicking \'Connect\', Sage will prompt you to ' +
        'authorize a connection to Sage Intacct.',
    LinkModalDescriptionExample: 'After clicking \'Connect\', you will be prompted to ' +
        'authorize a connection to DEX.',
    LinkModalDescriptionFreeAgent: 'After clicking \'Connect\', you will be prompted to ' +
        'authorize a connection to FreeAgent.',
    LinkModalDescriptionNetSuite: 'After clicking \'Connect\', you will be prompted to ' +
        'authorize a connection to NetSuite.',
    LinkModalDescriptionBusinessCentral: 'After clicking \'Connect\', you will be prompted to ' +
        'authorize a connection to Business Central.',
    LinkModalDescriptionMYOBBusiness: 'After clicking \'Connect\', you will be prompted to ' +
        'authorize a connection to MYOB Business.',
    LinkModalDescriptionFileUpload: 'After clicking \'Connect\', you will be prompted to ' +
        'select an Excel template file for upload.',
    LinkModalQBOneWay: 'Information in QuickBooks will never be altered in any way. This is a fully secure, one-way data stream.',
    LinkModalXeroOneWay: 'Information in Xero will never be altered in any way. This is a fully secure, one-way data stream.',
    LinkModalSageIntacctOneWay: 'Information in Sage Intacct will never be altered in any way. This is a fully secure, one-way data stream.',
    LinkModalExampleOneWay: 'Information in DEX will never be altered in any way. This is a fully secure, one-way data stream.', 
    LinkModalFreeAgentOneWay: 'Information in FreeAgent will never be altered in any way. This is a fully secure, one-way data stream.',
    LinkModalNetSuiteOneWay: 'Information in NetSuite will never be altered in any way. This is a fully secure, one-way data stream.',
    LinkModalBusinessCentralOneWay: 'Information in Business Central will never be altered in any way. This is a fully secure, one-way data stream.',
    LinkModalMYOBBusinessOneWay: 'Information in MYOB Business will never be altered in any way. This is a fully secure, one-way data stream.',
    LinkModalFileUploadOneWay: 'Information in your Excel template will never be altered in any way. This is a fully secure, one-way data stream.',
    LinkModalWorking: 'Working...',
    LinkModalUpdateFinancialsNow: 'Update Financials Now',
    TermsDescriptionParagraph1PreSBX: '${partnerName} uses',
    TermsDescriptionParagraph1PostSBX: 'to link to your accounting system',
    TermsDescriptionParagraph2: 'By selecting \'Continue\' you agree to the',
    TermsDescriptionParagraph2Href: 'Strongbox Terms of Service',
    TermsBullet1Title: 'Secure',
    TermsBullet1Description: 'Encryption protects your business\' financial data.',
    TermsBullet2Title: 'Private',
    TermsBullet2Description: 'Your credentials will never be made accessible to ${partnerName}.',
    TermsBullet3Title: 'Read-only connection',
    TermsBullet3Description: 'No information will be altered in your accounting system. This is a one-way data stream.',
    Connect: 'Connect',
}
